import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Card, Typography, Grid, TextField } from "@mui/material";
import { InsertDriveFile as FileIcon } from "@mui/icons-material";
import { renderIcon } from "../../../fieldFailureReports/components/CommonFunctions";
// Function to return the appropriate file icon
var getFileIcon = function (fileName) {
    if (!fileName)
        return /*#__PURE__*/ React.createElement(FileIcon, {
            sx: {
                fontSize: 40,
                color: "gray"
            }
        });
    return renderIcon(fileName);
};
var ViewAttachmentList = function (props) {
    var _value$name;
    var value = props.value, _a = props.name, name = _a === void 0 ? "FileAttachments" : _a, onChange = props.onChange, error = props.error, validator = props.validator;
    var currValue = (_value$name = value === null || value === void 0 ? void 0 : value[name]) !== null && _value$name !== void 0 ? _value$name : [];
    var validation = validator === null || validator === void 0 ? void 0 : validator(currValue, value);
    var handleChange = function (id, remark) {
        if (onChange) {
            var updatedAttachments = currValue.map(function (attachment) { return (attachment === null || attachment === void 0 ? void 0 : attachment.id) === id ? _objectSpread(_objectSpread({}, attachment), {}, {
                Remark: remark
            }) : attachment; });
            console.log("updatedAttachments", updatedAttachments);
            onChange(null, updatedAttachments);
        }
    };
    if (!currValue.length || currValue.every(function (file) { return (file === null || file === void 0 ? void 0 : file.IsDeleted) === 1; })) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2
    }, currValue.filter(function (file) { return file.IsDeleted !== 1; }).map(function (file) {
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 6,
            key: file.id
        }, /*#__PURE__*/ React.createElement(Card, {
            variant: "outlined",
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 2
            }
        }, getFileIcon((file === null || file === void 0 ? void 0 : file.FileName) || (file === null || file === void 0 ? void 0 : file.name) || (file === null || file === void 0 ? void 0 : file.fileName)), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                flex: 1,
                ml: 2,
                display: "flex",
                flexDirection: "column"
            }
        }, /*#__PURE__*/ React.createElement(Typography, null, (file === null || file === void 0 ? void 0 : file.FileName) || (file === null || file === void 0 ? void 0 : file.name) || (file === null || file === void 0 ? void 0 : file.fileName)), /*#__PURE__*/ React.createElement(Typography, {
            variant: "caption",
            color: "text.secondary"
        }, Math.round(((file === null || file === void 0 ? void 0 : file.size) || (file === null || file === void 0 ? void 0 : file.Size) || 0) / 1000), " KB"), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                mt: 1,
                width: "100%"
            }
        }, /*#__PURE__*/ React.createElement(TextField, {
            fullWidth: true,
            disabled: true,
            name: "Remark",
            placeholder: "Remark",
            onChange: function (e) {
                var _e$target;
                handleChange((file === null || file === void 0 ? void 0 : file.id) || "", e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
            },
            value: file === null || file === void 0 ? void 0 : file.Remark
        })))));
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        color: "error.main"
    }, " ", validation, " ")));
};
export default ViewAttachmentList;
